import { Breadcrumb } from 'antd'
import { Link } from 'react-router-dom'
import React from 'react'
import { routes } from '../../routes'
import { useLocation } from 'react-router-dom'
import { Home2OutlineIcon } from '../AppIcon'

const SimpleBreadCrumbV2 = props => {
  const { title, quarter } = props
  const location = useLocation()

  const isHome = location.pathname === '/dashboard' || location.pathname === '/'

  const pathSnippets =
    location !== undefined ? location.pathname.split('/').filter(i => i) : []

  let extraBreadcrumbItems

  if (title === 'Báo cáo định kỳ' || title === 'Báo cáo đột xuất') {
    extraBreadcrumbItems = pathSnippets
      .map((_, index) => {
        return `/${pathSnippets.slice(0, index + 1).join('/')}`
      })
      .map(url => routes.find(route => route.path === url))
      .filter(route => route)
      .map((route, index, array) => {
        let path = route.path
        if (
          route.path === '/report/periodic' ||
          route.path === '/report/extraordinary'
        ) {
          path += location.search
        }
        const name =
          index === array.length - 1 ? `${route.name} - ${quarter}` : route.name
        return (
          <Breadcrumb.Item key={path}>
            <Link to={path}>{name}</Link>
          </Breadcrumb.Item>
        )
      })
  } else {
    extraBreadcrumbItems = pathSnippets
      .map((_, index) => {
        return `/${pathSnippets.slice(0, index + 1).join('/')}`
      })
      .map(url => routes.find(route => route.path === url))
      .filter(route => route)
      .map(route => (
        <Breadcrumb.Item key={route.path}>
          <Link to={route.path}>{route.name}</Link>
        </Breadcrumb.Item>
      ))
  }

  const breadcrumbItems = [
    <Breadcrumb.Item
      key="home"
      href="/dashboard"
      className="breadcrumb-home-icon">
      <Home2OutlineIcon style={{ width: 16, height: 20, color: '#5B6B79' }} />
    </Breadcrumb.Item>,
  ].concat(extraBreadcrumbItems)

  if (isHome) {
    return (
      <p style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '0px' }}>
        Dashboard
      </p>
    )
  }

  return (
    <Breadcrumb
      separator={
        <span style={{ color: '#5B6B79', fontWeight: 'bold' }}>/</span>
      }
      className="app-breadcrumb">
      {breadcrumbItems}
    </Breadcrumb>
  )
}

export default SimpleBreadCrumbV2
